<template>
  <div id="setting-event" class="col-12" @mouseleave="updateEvents">
    <div class="form">
      <dl class="row">
        <dt class="col-md-3">เงื่อนไขการรับสิทธิ์</dt>
        <dd class="col-md-9">
          <label class="select-input" :class="isDisabledClass">
            <span>รับสิทธิ์ทันที</span>
            <input
              type="radio"
              value="IMMEDIATE"
              name="type"
              :disabled="!canUpdateContent"
              v-model="events.type"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input" :class="isDisabledClass">
            <span>ลงทะเบียน</span>
            <input
              type="radio"
              value="REGISTER"
              name="type"
              :disabled="!canUpdateContent"
              v-model="events.type"
            />
            <span class="checkmark radio"></span>
          </label>
          <dl class="form-options" v-if="showTypeOptions">
            <dt></dt>
            <dd>
              <label class="select-input" :class="isDisabledClass">
                <span>ให้มีคำถามในหน้าแบบฟอร์มลงทะเบียน</span>
                <input
                  type="checkbox"
                  v-model="conditions.question"
                  :disabled="!canUpdateContent"
                />
                <span class="checkmark checkbox"></span>
              </label>
              <div class="sub-input w-100" v-if="showTypeQuestionOptions">
                <small>พิมพ์คำถามที่คุณต้องการ</small>
                <input
                  type="text"
                  name="question"
                  class="form-control"
                  v-model="events.question"
                  :disabled="!canUpdateContent"
                />
              </div>
            </dd>
          </dl>
        </dd>
        <dt class="col-md-3">รูปแบบ Ticket</dt>
        <dd class="col-md-9" :class="isDisabledClass">
          <label class="select-input">
            <span>Activity Ticket</span>
            <input
              type="radio"
              value="ACTIVITY"
              name="usageType"
              v-model="events.usageType"
              :disabled="!canUpdateContent"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>Redeem Ticket</span>
            <input
              type="radio"
              value="REDEEM"
              name="usageType"
              v-model="events.usageType"
              :disabled="!canUpdateContent"
            />
            <span class="checkmark radio"></span>
          </label>
        </dd>

        <dt class="col-md-3">ระยะเวลารับสิทธิ์ / ลงทะเบียน</dt>
        <dd class="col-md-9" :class="isDisabledClass">
          <label class="form-group">
            <input
              type="hidden"
              name="activateDate"
              :value="activateDate[0]"
              v-validate="'required'"
              :disabled="!canUpdateContent"
            />
            <small>วันที่ / เวลา</small>
            <div class="clearfix">
              <el-date-picker
                v-model="activateDate"
                :class="{ error: errors.has('activateDate') }"
                :editable="false"
                :picker-options="datePickerOptions.notBeforeToday"
                :default-time="['00:00:00', '23:59:59']"
                :disabled="!canUpdateContent"
                @blur="validate"
                format="dd-MM-yyyy HH:mm"
                start-placeholder="เริ่มการลงทะเบียน"
                end-placeholder="สิ้นสุดการลงทะเบียน"
                range-separator="ถึง"
                type="datetimerange"
              >
              </el-date-picker>
            </div>
          </label>
        </dd>

        <dt class="col-md-3">รูปแบบรหัส</dt>
        <dd class="col-md-9" :class="isDisabledClass">
          <label class="select-input">
            <span>กำหนดเอง</span>
            <input
              type="radio"
              value="PREFIXED"
              v-model="conditions.codeType"
              :disabled="!canUpdateContent"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>อัพโหลดไฟล์รหัส</span>
            <input
              type="radio"
              value="PREDEFINED"
              v-model="conditions.codeType"
              :disabled="!canUpdateContent"
            />
            <span class="checkmark radio"></span>
          </label>

          <dl class="form-options">
            <div v-if="showRandomCodeOptions">
              <dt>กำหนดรูปแบบรหัส</dt>
              <dd>
                <label class="form-group">
                  <small>ระบุภาษาอังกฤษขึ้นต้น 2 ตัว</small>
                  <input
                    type="text"
                    value="SC"
                    name="prefixCode"
                    class="form-control"
                    v-model="events.prefixCode"
                    maxlength="2"
                    placeholder="SC"
                    :disabled="!canUpdateContent"
                  />
                </label>
                <label class="form-group">
                  <small>ตัวอย่างรหัส</small>
                  <div class="code-preview">
                    <em>{{ events.prefixCode }}</em>
                    <span>XXXXXX</span>
                  </div>
                </label>
              </dd>
            </div>
            <div v-if="showUploadCodeOptions">
              <dt>
                อัพโหลดไฟล์ CSV
                <img
                  class="pointer align-top ml-2"
                  src="/static/icons/information-circle.svg"
                  alt="info icon"
                  @click="showDialog = true"
                  width="22"
                  height="22"
                />
              </dt>
              <dd>
                <label class="form-group">
                  <input
                    type="file"
                    class="form-control"
                    accept=".csv"
                    @change="readCodesFromCSV($event.target.files[0])"
                    :disabled="!canUpdateContent"
                  />
                </label>
                <label class="form-group">
                  <small>จำนวนสิทธิ์</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="file.codes.length"
                    readonly
                  />
                </label>
                <div class="code-results">
                  <ul class="" v-if="file.codes.length > 0">
                    <li>ตัวอย่างรหัสจากไฟล์</li>
                    <li v-for="(code, i) in file.codes" :key="i">{{ code }}</li>
                  </ul>
                  <ul class="error" v-if="file.errors.length > 0">
                    <li>พบข้อผิดพลาดกับโค้ดต่อไปนี้</li>
                    <li v-for="(code, i) in file.errors" :key="i">
                      {{ code }}
                    </li>
                  </ul>
                </div>
              </dd>
            </div>
            <dt>วันจัดกิจกรรม / ระยะเวลาใช้สิทธิ์</dt>
            <dd>
              <label class="form-group">
                <input
                  type="hidden"
                  name="useDate"
                  :value="useDate[0]"
                  v-validate="'required'"
                />
                <small>วันที่ / เวลา</small>
                <div class="clearfix">
                  <el-date-picker
                    v-model="useDate"
                    :class="{ error: errors.has('useDate') }"
                    :picker-options="datePickerOptions.notBeforeToday"
                    :default-time="['00:00:00', '23:59:59']"
                    :disabled="!canUpdateContent"
                    @change="validate"
                    format="dd-MM-yyyy HH:mm"
                    start-placeholder="เริ่มกิจกรรม/ใช้สิทธิ์"
                    end-placeholder="สิ้นสุดกิจกรรม/ใช้สิทธิ์"
                    range-separator="ถึง"
                    type="datetimerange"
                  >
                  </el-date-picker>
                </div>
              </label>
            </dd>
            <div v-if="showQuotaOptions">
              <dt>จำนวนสิทธิ์</dt>
              <dd>
                <div>
                  <label class="select-input">
                    <span>จำกัดสิทธิ์</span>
                    <input
                      type="radio"
                      value="LIMITED"
                      name="quota"
                      v-model="conditions.quotaType"
                      :disabled="!canUpdateContent"
                    />
                    <span class="checkmark radio"></span>
                  </label>
                  <label class="select-input">
                    <span>ไม่จำกัดสิทธิ์</span>
                    <input
                      type="radio"
                      value="UNLIMITED"
                      name="quota"
                      v-model="conditions.quotaType"
                      :disabled="!canUpdateContent"
                    />
                    <span class="checkmark radio"></span>
                  </label>
                </div>
                <div v-if="showSpecificQuotaOptions">
                  <label class="sub-input">
                    <small>ระบุจำนวนสิทธิ์</small>
                    <input
                      type="text"
                      value=""
                      name="quotaPreview"
                      class="form-control"
                      v-model="events.quota"
                      :disabled="!canUpdateContent"
                    />
                  </label>
                </div>
              </dd>
            </div>
            <div v-if="showWaitingListOptions">
              <label class="select-input">
                <span>ให้มี Waiting List ( สิทธิ์สำรอง )</span>
                <input
                  type="checkbox"
                  value=""
                  v-model="conditions.waitingList"
                  :disabled="!canUpdateContent"
                />
                <span class="checkmark checkbox"></span>
              </label>
              <div v-if="showWaitingListQuotaOptions">
                <label class="sub-input">
                  <small>ระบุจำนวนสิทธิ์สำรอง</small>
                  <input
                    type="text"
                    value=""
                    name="totalReserve"
                    class="form-control"
                    v-model="events.totalReserve"
                    :disabled="!canUpdateContent"
                  />
                </label>
              </div>
            </div>
          </dl>
        </dd>
        <dt class="col-md-3">บาร์โค้ด</dt>
        <dd class="col-md-9" :class="isDisabledClass">
          <label class="select-input" :class="isDisabledClass">
            <span>แสดงบาร์โค้ด</span>
            <input
              type="radio"
              value="true"
              name="showBarcodeTrue"
              :disabled="!canUpdateContent"
              v-model="events.showBarcode"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input" :class="isDisabledClass">
            <span>ไม่แสดงบาร์โค้ด</span>
            <input
              type="radio"
              value="false"
              name="showBarcodeFalse"
              :disabled="!canUpdateContent"
              v-model="events.showBarcode"
            />
            <span class="checkmark radio"></span>
          </label>
          <dl class="form-options" >
            <div v-if="showBarcodeRemark">
            <dt>คำอธิบายใต้บาร์โค้ด</dt>
            <dd>
              <label class="form-group">
                <small>แก้ไขคำอธิบาย</small>
                  <input
                    type="text"
                    name="barcodeRemark"
                    class="form-control barcode-remark"
                    maxlength="200"
                    v-model="events.barcodeRemark"
                    placeholder="แสดง code นี้กับเจ้าหน้าที่เพื่อรับสิทธิ์"
                    :disabled="!canUpdateContent"
                  />
              </label>
            </dd>
            </div>
          </dl>
        </dd>
      </dl>
    </div>
    <info-dialog
      :title="'รูปแบบของไฟล์ CSV'"
      v-if="showDialog === true"
      @isShow="showDialog = false"
    >
      <div class="row">
        <div class="col-md-8">
          <img
            src="/static/pictures/article-guide-csv.jpg"
            alt="csv content guide"
            class="w-100"
          />
        </div>
        <div class="col-md-4">
          <p>
            รูปแบบของรหัส
            จะต้องประกอบด้วยตัวเลขหรือตัวหนังสือภาษาอังกฤษรวมทั้งหมด 8
            ตัวซึ่งจะต้องอยู่ในคอลัมน์เดียว และไม่ต้องใส่หัวตาราง ตามรูปประกอบ
          </p>
        </div>
      </div>
    </info-dialog>
  </div>
</template>
<script>
import csv from "csvtojson";
import Moment from "moment";
import { DatePicker } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Information from "@/components/helper/dialog/Information";

export default {
  props: ["eventSettings", "canUpdateContent", "isThaiLanguage"],
  components: {
    "el-date-picker": DatePicker,
    "info-dialog": Information
  },
  data() {
    return {
      conditions: {
        question: false,
        codeType: "PREFIXED",
        quotaType: "LIMITED",
        waitingList: false
      },
      datePickerOptions: {
        notBeforeToday: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 3600 * 1000 * 24;
          }
        }
      },
      events: {
        type: "IMMEDIATE", // or REGISTER
        usageType: "ACTIVITY", // or REDEEM
        startActivateDate: "",
        endActivateDate: "",
        startUseDate: "",
        endUseDate: "",
        prefixCode: "SC",
        quota: 10,
        totalReserve: 10,
        question: null,
        codes: null,
        showBarcode: true,
        barcodeRemark: "แสดง code นี้กับเจ้าหน้าที่เพื่อรับสิทธิ์"
      },
      file: {
        codes: [],
        errors: []
      },
      showDialog: false
    };
  },
  watch: {
    eventSettings() {
      this.events = this.eventSettings;

      this.events.startActivateDate = this.events.startActivateDate
        ? Moment(this.events.startActivateDate).toDate()
        : null;
      this.events.endActivateDate = this.events.endActivateDate
        ? Moment(this.events.endActivateDate).toDate()
        : null;
      this.events.startUseDate = this.events.startUseDate
        ? Moment(this.events.startUseDate).toDate()
        : null;
      this.events.endUseDate = this.events.endUseDate
        ? Moment(this.events.endUseDate).toDate()
        : null;

      if (this.events.question) {
        this.conditions.question = true;
      }

      if (this.events.codes && this.events.codes.length > 0) {
        this.conditions.codeType = "PREDEFINED";
        this.file.codes = this.events.codes;
      }

      if (!this.events.quota) {
        this.conditions.quotaType = "UNLIMITED";
      }

      if (this.events.totalReserve) {
        this.conditions.waitingList = true;
      }
    }
  },
  computed: {
    activateDate: {
      get() {
        return [
          this.events.startActivateDate || "",
          this.events.endActivateDate || ""
        ];
      },
      set(datetimeArray) {
        if (datetimeArray === null) {
          this.events.startActivateDate = "";
          this.events.endActivateDate = "";
        } else {
          this.events.startActivateDate = datetimeArray[0];
          this.events.endActivateDate = datetimeArray[1];
        }
      }
    },
    useDate: {
      get() {
        return [this.events.startUseDate || "", this.events.endUseDate || ""];
      },
      set(datetimeArray) {
        if (datetimeArray === null) {
          this.events.startUseDate = "";
          this.events.endUseDate = "";
        } else {
          this.events.startUseDate = datetimeArray[0];
          this.events.endUseDate = datetimeArray[1];
        }
      }
    },
    showTypeOptions() {
      if (this.events.type === "REGISTER") {
        return true;
      }

      return false;
    },
    showTypeQuestionOptions() {
      if (
        this.events.type === "REGISTER" &&
        this.conditions.question === true
      ) {
        return true;
      }

      return false;
    },
    showRandomCodeOptions() {
      if (this.conditions.codeType === "PREFIXED") {
        return true;
      }

      return false;
    },
    showUploadCodeOptions() {
      if (this.conditions.codeType === "PREDEFINED") {
        return true;
      }

      return false;
    },
    showQuotaOptions() {
      if (this.conditions.codeType === "PREFIXED") {
        return true;
      }

      return false;
    },
    showSpecificQuotaOptions() {
      if (this.conditions.quotaType === "LIMITED") {
        return true;
      }

      return false;
    },
    showWaitingListOptions() {
      if (
        this.events.type === "REGISTER" &&
        this.conditions.quotaType !== "UNLIMITED"
      ) {
        return true;
      }

      return false;
    },
    showWaitingListQuotaOptions() {
      if (this.conditions.waitingList === true) {
        return true;
      }

      return false;
    },
    showBarcodeRemark() {
      return JSON.parse(this.events.showBarcode);
    },
    isDisabledClass() {
      return {
        "disable-content": !this.isThaiLanguage
      };
    }
  },
  methods: {
    readCodesFromCSV(file) {
      const reader = new FileReader();
      const vm = this;

      vm.file.codes = [];
      vm.file.errors = [];

      reader.onload = () => {
        const options = {
          noheader: true,
          ignoreEmpty: true,
          output: "line"
        };

        csv(options)
          .fromString(reader.result)
          .preFileLine(line => {
            const cleaned = line.toString("utf8");

            vm.file.codes.push(cleaned);

            return cleaned;
          });
      };

      reader.readAsText(file);
    },
    updateEvents() {
      const editedEventSettings = {
        type: this.events.type,
        usageType: this.events.usageType,
        startActivateDate: this.events.startActivateDate || null,
        endActivateDate: this.events.endActivateDate || null,
        startUseDate: this.events.startUseDate || null,
        endUseDate: this.events.endUseDate || null,
        showBarcode: this.events.showBarcode || false,
        barcodeRemark: this.events.barcodeRemark || null
      };

      if (this.events.question && this.events.question.trim().length > 0) {
        editedEventSettings.question = this.events.question.trim();
      } else {
        editedEventSettings.question = null;
      }

      if (this.conditions.quotaType === "LIMITED" && this.events.quota > 0) {
        editedEventSettings.quota = this.events.quota;
      } else {
        editedEventSettings.quota = null;
      }

      if (this.conditions.waitingList && this.events.totalReserve > 0) {
        editedEventSettings.totalReserve = this.events.totalReserve;
      } else {
        editedEventSettings.totalReserve = null;
      }

      if (this.showRandomCodeOptions) {
        editedEventSettings.prefixCode = this.events.prefixCode;
      } else {
        editedEventSettings.prefixCode = "SC";
      }

      if (this.showUploadCodeOptions && this.file.codes.length > 0) {
        this.events.codes = this.file.codes;
        editedEventSettings.codes = this.file.codes;
        editedEventSettings.quota = this.file.codes.length;
      } else {
        this.events.codes = null;
      }

      this.$emit("setEvents", editedEventSettings);
    },
    async validate() {
      const result = await this.$validator.validate();
      this.$emit("validate", result);
      return result;
    }
  },
  created() {
  }
};
</script>
<style lang="scss" scoped>
#setting-event {
  overflow-y: scroll;
  height: calc(100vh - 312px);
}
.form {
  padding: 25px 0;

  strong {
    display: inline-block;
    vertical-align: bottom;
    margin: 1rem;
  }

  small {
    font-size: 11px;
    font-weight: 500;
    line-height: 1.64;
    letter-spacing: -0.1px;
    color: #8c8786;
  }

  dt {
    text-align: right;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
  }

  input:not([type="file"]) {
    color: $black;
    font-weight: bold;
  }

  input:not([type="checkbox"]):not([type="radio"]) {
    padding: 4px 4px 4px 0;
  }

  input[type="file"] {
    height: 35px;
  }

  input[data-prefix] {
    content: attr(data-prefix);
    color: $black;
    display: inline;
  }

  &-options {
    padding: 16px;
    border-radius: 5px;
    background-color: #f9f9f9;

    dt {
      text-align: left;
    }
    .select-input {
      margin-top: 8px;
    }
    .sub-input {
      padding-left: 36px;
    }
  }

  .form-control {
    background-color: transparent;
    border-color: #e0e0e0;
  }
  .barcode-remark {
    width: 400px;
  }
  .select-input {
    color: $black;
  }
  .time-picker-wrapper {
    font-size: 18px;
    font-weight: bold;
    border: none;
    border-bottom: solid 1px #e0e0e0;
    height: 30px;
    margin-top: 0;
    float: left;
    min-width: 220px;
  }
  .date-append-img {
    float: left;
    margin-top: 5px;
    margin-left: -25px;
  }
  .code-preview {
    margin-top: 4px;
    color: $black;
    font-size: 16px;

    em {
      font-weight: bold;
      font-style: normal;
    }
  }
  .code-results {
    ul {
      padding-left: 0;
      margin: 0;
      max-height: 100px;
      overflow: scroll;

      &.error {
        color: $red;
      }

      li {
        font-size: 11px;
        list-style-type: square;
        margin-left: 16px;

        &:first-child {
          margin-left: 0;
          padding-left: 0;
          list-style: none;
        }
      }
    }
  }
}

.disable-content {
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/create/ContentEvent.vue